import React from 'react'
import Translation from './Translation'

export const typeMap = {
    SLAB: <Translation id="tables" defaultMessage="Slabs" />,
    MK: <Translation id="mktool" defaultMessage="Marketing Tools" />,
    SH: <Translation id="showroom" defaultMessage="Showroom" />,
    WH: <Translation id="warehouse" defaultMessage="Warehouse" />,
    OPERATIONS: <Translation id="OPERATIONS" defaultMessage="Operations" />,
    SERVICE: <Translation id="SERVICE" defaultMessage="Services" />,
    '01': <Translation id="SAMPLES" defaultMessage="Samples" />,
    '02': <Translation id="OTHERS" defaultMessage="Others" />,
    '03': <Translation id="MERCHANDISING" defaultMessage="Merchandising" />,
    '04': <Translation id="LITERATURE" defaultMessage="Literature" />,
    '05': <Translation id="TAGS" defaultMessage="Tags" />,
    '06': <Translation id="ANCHORING" defaultMessage="anchoring" />,
    '07': <Translation id="BOXES" defaultMessage="Boxes" />,
    '08': <Translation id="DISPLAYS" defaultMessage="Displays" />,
    '09': <Translation id="BOOKS" defaultMessage="Books" />,
    '10': <Translation id="CABINETS" defaultMessage="Cabinets" />,
    '11': <Translation id="SIGNAGE" defaultMessage="Signage" />,
    '12': <Translation id="TEST_KITS" defaultMessage="Test kits" />,
    '13': <Translation id="WORKWEAR" defaultMessage="Workwear" />,
    '14': <Translation id="EPP" defaultMessage="EPP" />,
    '15': <Translation id="WAREHOUSE_SUPPLIES" defaultMessage="warehouse supplies" />,
    // Nuevos tipos
    BASIN: <Translation id="basins" defaultMessage="Basins" />,
    VANITY: <Translation id="vanity_basin" defaultMessage="Vanity basin" />,
    SINK: <Translation id="sinks" defaultMessage="Sinks" />,
    STRAY: <Translation id="subtype_shower_tray" defaultMessage="Shower trays" />,
    TILE: <Translation id="tile" defaultMessage="Tile" />,
    CLAD: <Translation id="wall_clading" defaultMessage="Wall cladding" />,
    FLOOR: <Translation id="soleria" defaultMessage="Soleria" />,
    CLAD_FLOOR: <Translation id="flooring_cladding" defaultMessage="Flooring & Cladding" />,
    ELAB: <Translation id="manufactured_products" defaultMessage="Manufactured products" />,
    PAN: <Translation id="panels" defaultMessage="Panels" />,
    'PANEL RANURADO': <Translation id="grooved_panel" defaultMessage="Grooved panel" />,
    ACC: <Translation id="accessories" defaultMessage="Accessories" />,
    C_M: <Translation id="cleaning_&_maintenance" defaultMessage="Cleaning & Maintenance" />,
    TOOL: <Translation id="tools" defaultMessage="Tools" />,
    AD: <Translation id="adhesives" defaultMessage="Adhesives" />,
    SIL: <Translation id="silicones" defaultMessage="Silicones" />,
}